import React, { useEffect, useRef } from 'react';
import logo from './logo.svg';

// import Header from "./components/header";
import TopMenu from "./components/topMenu";
import LeftMenu from "./components/leftMenu";
import DesignRightMenu from "./components/designRightMenu";
import LoadingSpinner from "./components/layout/spinner";
import Home from "./pages/home";
import SurveyDetail from "./pages/surveyDetail";
import UserSurvey from "./pages/userSurvey";
import { Auth, Hub } from 'aws-amplify';
import { withAuthenticator, useTheme, Heading, View, Image } from '@aws-amplify/ui-react';
import { setThemeMode } from "./store/actions"
import { addUserEnvironmentFromAPI } from './services/userEnvironmentService';
import { Routes, Route, useLocation ,Outlet} from "react-router-dom";
import { PrimeReactProvider } from 'primereact/api';
import { useSelector, useDispatch } from 'react-redux';

import packageJson from '../package.json';

import logoBlack from '../src/assets/logo/maturytics_logo_black.svg';

import './App.css';
import '@aws-amplify/ui-react/styles.css';
import HelpPage from './components/help';
import UserGuide from './components/help/userGuide';
// import '../src/custom-primeflex.css';
// import '/node_modules/primereact/resources/themes/lara-light-blue/theme.css';
// import 'primeicons/primeicons.css';

function App({ signOut, user }) {
  const themeMode = useSelector(state => state.themeMode);
  // const leftMenuWidth = useSelector(state => state.leftMenuWidth);
  const rightMenuWidth = useSelector(state => state.rightMenuWidth);
  //  const leftMenuVisibility = useSelector(state => state.leftMenuVisibility);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);
// console.log("app.js")
  // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
  const leftMenuWidth = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.leftMenuWidth;
  // const rightMenuWidth = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.rightMenuWidth;
  const leftMenuVisibility = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.leftMenuVisibility;
  const pageIsLoading = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.pageIsLoading;

  const getBrowser = () => {
    const userAgent = navigator.userAgent;
    let browser = '';
    if (userAgent.indexOf("Chrome") > -1) {
      browser = "Chrome";
    } else if (userAgent.indexOf("Firefox") > -1) {
      browser = "Firefox";
    } else if (userAgent.indexOf("Safari") > -1) {
      browser = "Safari";
    } else if (userAgent.indexOf("Edge") > -1) {
      browser = "Edge";
    } else if (userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident") > -1) {
      browser = "Internet Explorer";
    }
    return browser;
  };

  const getOS = () => {
    const userAgent = navigator.userAgent;
    let os = '';
    // İşletim sistemini tanımlama
    if (userAgent.indexOf("Win") > -1) {
      os = "Windows";
    } else if (userAgent.indexOf("Mac") > -1) {
      os = "Mac OS";
    } else if (userAgent.indexOf("Linux") > -1) {
      os = "Linux";
    } else if (userAgent.indexOf("Android") > -1) {
      os = "Android";
    } else if (userAgent.indexOf("iPhone") > -1 || userAgent.indexOf("iPad") > -1) {
      os = "iOS";
    }
    return os;
  };

  const fetchIPAddress = async () => {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      if (!response.ok) {
        return "IP adresi alınamadı.";
      }
      const data = await response.json();
      return data.ip;
    } catch (err) {
      return "IP adresi alınamadı.";
    }
  };

const processedSignIn = useRef(false);
  useEffect(() => {
    const listener = (state) => {

    if (state.payload?.event !== "signIn") return;

    if (state.payload.event === 'signIn' && !processedSignIn.current) {
        let ipAddress = "";
        fetchIPAddress().then((ip) => {
          ipAddress = ip;
        });

        setTimeout(() => {
          const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          const language = navigator.language;
          const browser = getBrowser();
          const os = getOS();
          const obj = {
            "user_id": state.payload.data.signInUserSession.idToken.payload.sub,
            "user_full_name": state.payload.data.signInUserSession.idToken.payload.name + " " + state.payload.data.signInUserSession.idToken.payload.family_name,
            "ip_address": ipAddress,
            "time_zone": timeZone,
            "language": language,
            "browser": browser,
            "os": os
          };

          addUserEnvironmentFromAPI(state.payload.data.signInUserSession.idToken.jwtToken, obj).then((res) => {
       
          }).catch((err) => {
          });

        }, 1000);
    }
    };

    Hub.listen('auth', listener);

    return () => {
      Hub.remove('auth', listener);
    };
  }, []);

  // const HomeWithAuth = withAuthenticator(Home, { components: c_components, formFields: c_formFields, hideSignUp: true });
  const location = useLocation();

  const dispatch = useDispatch();

  useEffect(() => {
    const savedThemeMode = localStorage.getItem("themeMode");

    if (savedThemeMode && savedThemeMode !== themeMode) {
      dispatch(setThemeMode(savedThemeMode));
    } else if (!savedThemeMode && themeMode !== "dark") {
      dispatch(setThemeMode("dark"));
    }
  }, [dispatch, themeMode]);
  useEffect(() => {
  }, [topMenuTabs])
 
  return (
    <div className={`flex flex-col min-h-[100vh] w-full overflow-hidden ${(themeMode === "dark" && !location.pathname.includes("/survey/")) ? "bg-[#14141f]" : "bg-[#fbfbfc]"}`} version={packageJson.version}>
      {!location.pathname.includes("/survey/") && (
        <div>
          <div className="fixed top-0 left-0 right-0 z-10">
            <TopMenu />
          </div>
          <div className="flex flex-1 overflow-hidden pt-[36px] min-h-[100vh]">
            <div className="w-26 h-full overflow-auto">
              <LeftMenu />
            </div>
            <div
              className="flex-1 overflow-y-auto overflow-x-hidden ml-0"
              style={{
                marginLeft: leftMenuVisibility === "hide" ? "0px" : `${leftMenuWidth}px`,
                marginRight: `${location.pathname.includes("/design") ? rightMenuWidth : "0"}px`
              }}
            >
              <div
                className={`w-full h-full flex border-b template-body ${themeMode === "dark" ? "bg-[#1a1a28] border-white/5" : "bg-[#FBFBFC] border-zinc-950/5"
                  }`}
              >
                 <Outlet />
                {/* <Routes className="flex-grow h-full">
                  <Route path="/" element={<Home />} />
                  <Route path="/home/*" element={<Home />} />
                  <Route path="/surveys/:survey_id/*" element={<SurveyDetail />} />
                  <Route path="/help" element={<HelpPage />} />
                  <Route path="/help/userGuide" element={<UserGuide />} />
                  
               
                </Routes> */}
              </div>
            </div>
            {location.pathname.includes("/design") && (
              <div className="w-26  h-full overflow-auto">
                <DesignRightMenu />
              </div>
            )}
          </div>
        </div>
      )}
      {location.pathname.includes("/survey/") && (
        <div>
          <Routes className="flex-grow h-full">
            <Route path="/survey/:user_survey_id/" element={<UserSurvey />} />
          </Routes>
        </div>
      )}
      {pageIsLoading && (
        <LoadingSpinner />
      )}
    </div>
  );
}

const c_components = {
  SignIn: {
    Header() {
      const { tokens } = useTheme();

      return (
        <View textAlign="center" padding={tokens.space.large}>
          <Image
            alt="Amplify logo"
            src={logoBlack}
            width="70%"
          />
          <Heading
            padding={`${tokens.space.xl} 0 0 0`}
            level={3}
          >
            Sign in to your account
          </Heading>
        </View>

      );
    },
  },
};

const c_formFields = {
}

export default withAuthenticator(App, { components: c_components, formFields: c_formFields, hideSignUp: true });

